import React, { useState } from 'react';
import { Box, Text, Flex, Icon } from '@chakra-ui/react';
import { FiChevronRight } from 'react-icons/fi';
import { FaUpload, FaLink } from 'react-icons/fa';
import UploadContentModal from './UploadContentModal';
import SubmitLinkModal from './SubmitLinkModal';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface AddWorkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddWorkModal: React.FC<AddWorkModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [linkModalOpen, setLinkModalOpen] = useState(false);

  const handleUploadFile = () => {
    onClose();
    // Open after the chooser sheet closes so focus/stacking and file modal work on mobile.
    setTimeout(() => setUploadModalOpen(true), 0);
  };

  const handleUploadViaLink = () => {
    onClose();
    setTimeout(() => setLinkModalOpen(true), 0);
  };

  return (
    <>
    <ModalShell isOpen={isOpen} onClose={onClose} title="Add work">
      <Box border="1px solid" borderColor={ff.line} borderRadius="20px" overflow="hidden">
        <Flex
          as="button"
          type="button"
          w="100%"
          textAlign="left"
          align="center"
          gap={4}
          px={4}
          py={4}
          minH="72px"
          bg="white"
          transition="background 0.2s"
          _hover={{ bg: ff.grey }}
          onClick={handleUploadFile}
        >
          <Flex w="44px" h="44px" align="center" justify="center" bg={ff.lime} borderRadius="full" flexShrink={0}>
            <Icon as={FaUpload} boxSize={4} color={ff.ink} />
          </Flex>
          <Text flex={1} fontFamily="display" fontWeight={600} fontSize="16px" color={ff.ink}>
            Upload file
          </Text>
          <Icon as={FiChevronRight} color={ff.muted} boxSize={5} />
        </Flex>

        <Flex
          as="button"
          type="button"
          w="100%"
          textAlign="left"
          align="center"
          gap={4}
          px={4}
          py={4}
          minH="72px"
          bg="white"
          borderTop="1px solid"
          borderColor={ff.line}
          transition="background 0.2s"
          _hover={{ bg: ff.grey }}
          onClick={handleUploadViaLink}
        >
          <Flex w="44px" h="44px" align="center" justify="center" bg={ff.lime} borderRadius="full" flexShrink={0}>
            <Icon as={FaLink} boxSize={4} color={ff.ink} />
          </Flex>
          <Box flex={1}>
            <Text fontFamily="display" fontWeight={600} fontSize="16px" color={ff.ink} mb={0.5}>
              Upload via link
            </Text>
            <Text fontSize="13px" color={ff.text2}>
              Instagram & TikTok links only
            </Text>
          </Box>
          <Icon as={FiChevronRight} color={ff.muted} boxSize={5} />
        </Flex>
      </Box>
    </ModalShell>

    {/* Upload Content Modal */}
    <UploadContentModal
      isOpen={uploadModalOpen}
      onClose={() => setUploadModalOpen(false)}
      onSuccess={onSuccess}
    />

    {/* Submit Link Modal */}
    <SubmitLinkModal
      isOpen={linkModalOpen}
      onClose={() => setLinkModalOpen(false)}
      onSuccess={onSuccess}
    />
    </>
  );
};

export default AddWorkModal;
